// Bridge: when running inside the Expo app webview, redirect profile clicks to
// the native NativeUserProfile screen instead of rendering the in-page web
// profile (modal / bottom sheet / Link to /profile/:id).
//
// The Expo side (LoadingWebView.tsx) listens for {type:"NAVIGATE_TO_NATIVE_PROFILE", userId}
// and pushes the native profile screen.
//
// Returns true when the click was forwarded to native (callers should bail
// out of their default behaviour). Returns false on web — callers should
// proceed with the normal flow (open modal, follow Link, etc).
export function openNativeProfile(userId) {
  if (typeof window === "undefined") return false;
  if (!window.isInApp || !window.ReactNativeWebView) return false;
  if (!userId) return false;
  try {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({ type: "NAVIGATE_TO_NATIVE_PROFILE", userId })
    );
    return true;
  } catch {
    return false;
  }
}
